import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { MenuItem } from '@app/shell/model/menu-item';
import { UserFacade } from '@app/store/user';
import { MenuItemComponent } from './item/item.component';
import { ProfileComponent } from './profile/profile.component';
import { bottomMenuItems, menuItems } from '../../config/menu.config';
import { LearningStreakComponent } from '@app/shared/components/learning-streak/learning-streak.component';
import { ProfileStatisticsFacade } from '@app/store/profile-statistics';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [CommonModule, TranslateModule, MenuItemComponent, ProfileComponent, LearningStreakComponent],
})
export class MenuComponent {
    private readonly userFacade = inject(UserFacade);
    private readonly profileStatisticsFacade = inject(ProfileStatisticsFacade);

    private readonly userRole = computed(() => this.userFacade.user()?.role ?? null);
    readonly daysInARow = computed(() => this.profileStatisticsFacade.statistics()?.daysInARow ?? 0);
    readonly bottomMenuItems = computed<MenuItem[]>(() => {
        const items = [...bottomMenuItems];

        if (this.userRole() === 'admin') {
            items.unshift({
                type: 'outlet',
                label: marker('form.header.admin.button.label'),
                icon: 'briefcase',
                outlets: { admin: 'menu' },
                activeRoute: ['admin'],
                testId: 'nav-admin',
            });
        }

        return items;
    });

    readonly menuItems = computed(() => menuItems);
}
